import type { SVGProps } from "react";

export const HowItWorksConnectingLine = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 1200 600" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M 144 230 C 200 320 280 360 360 260 C 444 200 528 200 612 260 C 696 320 780 320 864 260 C 948 200 1032 200 1116 260 C 1152 285 1170 292 1188 285"
        stroke="currentColor"
        strokeWidth="3"
        strokeDasharray="10 14"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
